import { jsx as r } from "react/jsx-runtime";
import { $ as l, M as o } from "../../ModalDialog-zU6ym3RG.js";
const t = ({ isDismissable: a = !0, ...e }) => e.isOpen ? /* @__PURE__ */ r(l, { children: /* @__PURE__ */ r(o, { ...e, isDismissable: a, children: e.children }) }) : null;
export {
  t as Modal
};
